import { ClerkProvider } from "@clerk/clerk-react";

const publishableKey: string | undefined = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

function MissingClerkConfig() {
  return (
    <div className="flex h-full items-center justify-center bg-bg p-6 text-center">
      <div className="max-w-md space-y-2">
        <h1 className="text-xl font-bold text-text">Clerk keys missing</h1>
        <p className="text-sm text-muted">
          Add <code className="text-text">VITE_CLERK_PUBLISHABLE_KEY</code> and{" "}
          <code className="text-text">CLERK_SECRET_KEY</code> from a Clerk development
          instance to <code className="text-text">.env</code>, then restart{" "}
          <code className="text-text">npm run dev</code>.
        </p>
      </div>
    </div>
  );
}

/** Provides Clerk; route-level auth lives in `RequireAuth` + `/sign-in`. */
export function AuthGate({ children }: { children: React.ReactNode }) {
  if (typeof publishableKey !== "string" || publishableKey.length === 0) {
    return <MissingClerkConfig />;
  }

  return (
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/sign-in">
      {children}
    </ClerkProvider>
  );
}
